"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Expando = require("./Expando");

var _Expando2 = _interopRequireDefault(_Expando);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ThingLink = function ThingLink(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$Expando = _ref.Expando,
      Expando = _ref$Expando === undefined ? _Expando2.default : _ref$Expando,
      _ref$Timestamp = _ref.Timestamp,
      Timestamp = _ref$Timestamp === undefined ? function (_ref2) {
    var created = _ref2.created;
    return created;
  } : _ref$Timestamp,
      onClick = _ref.onClick,
      onShare = _ref.onShare,
      onSave = _ref.onSave,
      onHide = _ref.onHide,
      onReport = _ref.onReport,
      onVoteUp = _ref.onVoteUp,
      onVoteDown = _ref.onVoteDown,
      isVoting = _ref.isVoting,
      isDetail = _ref.isDetail,
      id = _ref.id,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === undefined ? false : _ref$expanded,
      name = _ref.name,
      author = _ref.author,
      domain = _ref.domain,
      over_18 = _ref.over_18,
      rank = _ref.rank,
      stickied = _ref.stickied,
      score = _ref.score,
      downs = _ref.downs,
      ups = _ref.ups,
      likes = _ref.likes,
      num_comments = _ref.num_comments,
      subreddit = _ref.subreddit,
      subreddit_id = _ref.subreddit_id,
      title = _ref.title,
      author_flair_text = _ref.author_flair_text,
      author_flair_css_class = _ref.author_flair_css_class,
      link_flair_text = _ref.link_flair_text,
      link_flair_css_class = _ref.link_flair_css_class,
      url = _ref.url,
      linkTarget = _ref.linkTarget,
      is_self = _ref.is_self,
      created = _ref.created,
      created_utc = _ref.created_utc,
      _ref$expandoType = _ref.expandoType,
      expandoType = _ref$expandoType === undefined ? "selftext" : _ref$expandoType,
      selftext = _ref.selftext,
      selftext_html = _ref.selftext_html,
      permalink = _ref.permalink,
      thumbnail = _ref.thumbnail,
      locked = _ref.locked,
      brand_safe = _ref.brand_safe,
      preview = _ref.preview,
      secure_media_embed = _ref.secure_media_embed,
      banned_by = _ref.banned_by,
      meta_thing = _ref.meta_thing,
      siteprefix = _ref.siteprefix,
      scoreTooltip = _ref.scoreTooltip,
      onToggleExpando = _ref.onToggleExpando,
      props = _objectWithoutProperties(_ref, ["Link", "Expando", "Timestamp", "onClick", "onShare", "onSave", "onHide", "onReport", "onVoteUp", "onVoteDown", "isVoting", "isDetail", "id", "expanded", "name", "author", "domain", "over_18", "rank", "stickied", "score", "downs", "ups", "likes", "num_comments", "subreddit", "subreddit_id", "title", "author_flair_text", "author_flair_css_class", "link_flair_text", "link_flair_css_class", "url", "linkTarget", "is_self", "created", "created_utc", "expandoType", "selftext", "selftext_html", "permalink", "thumbnail", "locked", "brand_safe", "preview", "secure_media_embed", "banned_by", "meta_thing", "siteprefix", "scoreTooltip", "onToggleExpando"]);

  return _react2.default.createElement(
    "div",
    {
      className: ["thing id-" + id + " odd link " + (stickied ? "stickied" : ""), banned_by ? "spam" : "", is_self ? "self" : "", locked ? "locked" : "", (link_flair_css_class || link_flair_text) && "linkflair" || "", link_flair_css_class && "linkflair-" + link_flair_css_class || ""].join(" "),
      "data-author": author,
      "data-author-fullname": "",
      "data-domain": domain,
      "data-fullname": name,
      "data-rank": rank,
      "data-subreddit": subreddit,
      "data-subreddit-fullname": subreddit_id,
      "data-timestamp": created_utc,
      "data-type": "link",
      "data-url": url,
      id: "thing_" + name,
      onClick: onClick
    },
    _react2.default.createElement("p", { className: "parent" }),
    rank ? _react2.default.createElement(
      "span",
      { className: "rank" },
      rank
    ) : null,
    _react2.default.createElement(
      "div",
      { className: "midcol " + (likes === false ? "dislikes" : likes === true ? "likes" : "unvoted") },
      onVoteUp ? _react2.default.createElement("div", {
        "aria-label": "upvote",
        className: "arrow " + (likes === true ? "upmod" : "up") + " login-required access-required",
        "data-event-action": "upvote",
        role: "button",
        tabIndex: 0,
        onClick: onVoteUp
      }) : null,
      isVoting ? _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "div",
          { className: "score dislikes" },
          _react2.default.createElement(
            "div",
            { className: "loading working" },
            _react2.default.createElement("div", { className: "throbber" })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "score unvoted" },
          _react2.default.createElement(
            "div",
            { className: "loading working" },
            _react2.default.createElement("div", { className: "throbber" })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "score likes" },
          _react2.default.createElement(
            "div",
            { className: "loading working" },
            _react2.default.createElement("div", { className: "throbber" })
          )
        )
      ) : _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "div",
          { className: "score dislikes", title: scoreTooltip },
          score > 10000 ? (score / 1000.0).toFixed(1) + "k" : score
        ),
        _react2.default.createElement(
          "div",
          { className: "score unvoted", title: scoreTooltip },
          score > 10000 ? (score / 1000.0).toFixed(1) + "k" : score
        ),
        _react2.default.createElement(
          "div",
          { className: "score likes", title: scoreTooltip },
          score > 10000 ? (score / 1000.0).toFixed(1) + "k" : score
        )
      ),
      onVoteDown ? _react2.default.createElement("div", {
        "aria-label": "downvote",
        className: "arrow " + (likes === false ? "downmod" : "down") + " login-required access-required",
        "data-event-action": "downvote",
        role: "button",
        tabIndex: 0,
        onClick: onVoteDown
      }) : null
    ),
    thumbnail && !["image", "default", "nsfw", "self"].find(function (sub) {
      return sub === thumbnail;
    }) ? _react2.default.createElement(
      Link,
      {
        className: "thumbnail may-blank loggedin",
        href: url,
        target: is_self ? null : linkTarget
      },
      _react2.default.createElement("img", {
        alt: "Thumb",
        height: 70,
        src: thumbnail,
        width: 70
      })
    ) : null,
    thumbnail === "self" ? _react2.default.createElement(Link, { className: "thumbnail may-blank loggedin self" }) : null,
    _react2.default.createElement(
      "div",
      { className: "entry unvoted" },
      _react2.default.createElement(
        "p",
        { className: "title" },
        link_flair_text || link_flair_css_class ? _react2.default.createElement(
          "span",
          { className: "linkflairlabel", title: link_flair_text },
          link_flair_text
        ) : null,
        _react2.default.createElement(
          Link,
          {
            className: "title may-blank loggedin",
            href: url,
            tabIndex: rank,
            target: is_self ? null : linkTarget
          },
          title
        ),
        " ",
        domain ? _react2.default.createElement(
          "span",
          { className: "domain" },
          "(",
          _react2.default.createElement(
            Link,
            { href: "/domain/" + domain + "/" },
            domain
          ),
          ")"
        ) : null
      ),
      onToggleExpando && !(isDetail && is_self) ? _react2.default.createElement("div", {
        title: "toggle",
        className: "expando-button " + (expanded ? "expanded" : "collapsed") + " " + expandoType,
        role: "button",
        onClick: onToggleExpando
      }) : null,
      _react2.default.createElement(
        "p",
        { className: "tagline" },
        "submitted ",
        _react2.default.createElement(Timestamp, { created: created, created_utc: created_utc }),
        author ? _react2.default.createElement(
          _react.Fragment,
          null,
          " by ",
          _react2.default.createElement(
            Link,
            {
              className: "author may-blank",
              href: "/user/" + author
            },
            author
          ),
          subreddit ? "to " : ""
        ) : subreddit ? " to " : "",
        subreddit ? _react2.default.createElement(
          Link,
          {
            className: "subreddit hover may-blank",
            href: "/" + siteprefix + "/" + subreddit
          },
          siteprefix,
          "/",
          subreddit
        ) : null
      ),
      isDetail && selftext ? (0, _util.optional)(Expando, _extends({}, props, { expanded: expanded, is_self: is_self, selftext: selftext, selftext_html: selftext_html })) : null,
      _react2.default.createElement(
        "ul",
        { className: "flat-list buttons" },
        over_18 ? _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "span",
            { className: "nsfw-stamp stamp" },
            _react2.default.createElement(
              "acronym",
              { title: "not safe for work" },
              "nsfw"
            )
          )
        ) : null,
        permalink ? _react2.default.createElement(
          "li",
          { className: "first" },
          _react2.default.createElement(
            Link,
            {
              className: "bylink comments may-blank",
              "data-event-action": "comments",
              href: permalink,
              rel: "nofollow"
            },
            num_comments,
            " comments"
          )
        ) : null,
        onShare ? _react2.default.createElement(
          "li",
          { className: "share" },
          typeof onShare === "string" ? _react2.default.createElement(
            "a",
            { className: "post-sharing-button", href: onShare, target: "_blank" },
            "share"
          ) : _react2.default.createElement(
            "a",
            { className: "post-sharing-button", onClick: onShare },
            "share"
          )
        ) : null,
        onSave ? _react2.default.createElement(
          "li",
          { className: "link-save-button save-button" },
          _react2.default.createElement(
            "a",
            null,
            "save"
          )
        ) : null,
        onHide ? _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "form",
            { className: "state-button hide-button" },
            _react2.default.createElement("input", { name: "executed", type: "hidden", defaultValue: "hidden" }),
            _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement(
                "a",
                { "data-event-action": "hide" },
                "hide"
              )
            )
          )
        ) : null,
        onReport ? _react2.default.createElement(
          "li",
          { className: "report-button" },
          _react2.default.createElement(
            "a",
            { className: "action-thing reportbtn access-required", "data-event-action": "report" },
            "report"
          )
        ) : null,
        banned_by ? _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "b",
            null,
            "[removed by ",
            banned_by,
            "]"
          )
        ) : null,
        locked ? _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "b",
            null,
            "[locked]"
          )
        ) : null,
        !brand_safe ? _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "span",
            { className: "nsfw-stamp stamp" },
            _react2.default.createElement(
              "acronym",
              { title: "not safe for brand" },
              "nsfb"
            )
          )
        ) : null,
        meta_thing ? _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            Link,
            { href: meta_thing.data.permalink, title: meta_thing.data.score + " points" },
            meta_thing.data.num_comments,
            " comments on ",
            siteprefix,
            "/",
            meta_thing.data.subreddit
          )
        ) : null
      ),
      isDetail && selftext ? null : (0, _util.optional)(Expando, _extends({}, props, { expanded: expanded, is_self: is_self, selftext: selftext, selftext_html: selftext_html })),
      _react2.default.createElement("div", { className: "reportform" })
    ),
    _react2.default.createElement("div", { className: "child" }),
    _react2.default.createElement("div", { className: "clearleft" })
  );
};

exports.default = ThingLink;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/ThingLink.js
// module id = 302
// module chunks = 0